import { CommonDependency } from '@/dependency';
import { MentionItem, TagInfo } from '../types';

export const tagListSearch = async (
  q: string,
): Promise<{
  tags: TagInfo[];
}> => {
  if (!q) {
    return Promise.resolve({
      tags: [],
    });
  }
  // return request.get(`/feed/tag/search`, { q });
  return CommonDependency.api.fetchTagSearch({ q });
};

export const mentionUserSearch = async (
  q: string,
): Promise<{
  mention: MentionItem | null;
}> => {
  if (!q) {
    return Promise.resolve({
      mention: null,
    });
  }
  // return request.get(`/feed/suggested_mention`, { q });
  return CommonDependency.api.fetchSuggestedMention({ q });
};
